// SidebarButton Component
// Reusable button component for sidebar (social buttons and navigation arrows)

import React from 'react';
import './SidebarButton.css';

function SidebarButton({
  icon,
  iconClass,
  isText = false,
  className = '',
  onClick,
  href,
  target,
  rel,
  ariaLabel,
  children
}) {
  const baseClassName = 'sidebar-button';
  const fullClassName = `${baseClassName} ${className}`.trim();

  // Handle click and blur immediately to prevent focus from staying
  const handleClick = (e) => {
    // Blur immediately before onClick to prevent focus styles
    const target = e.currentTarget;
    if (target) {
      target.blur();
    }
    
    if (onClick) {
      onClick(e);
    }
  };
  
  // Handle mousedown to prevent focus from being set
  const handleMouseDown = (e) => {
    // For buttons, prevent default to stop focus
    if (!href) {
      e.preventDefault();
    }
  };

  // Render icon or text
  const renderIcon = () => {
    if (isText && icon) {
      return <span className="sidebar-icon-text">{icon}</span>;
    } else if (iconClass) {
      return <i className={iconClass}></i>;
    } else if (icon) {
      return <span className="sidebar-icon-text">{icon}</span>;
    }
    return children;
  };

  // If href is provided, render as link, otherwise as button
  if (href) {
    return (
      <a
        href={href}
        target={target}
        rel={rel}
        className={fullClassName}
        aria-label={ariaLabel}
        onClick={handleClick}
        onMouseDown={handleMouseDown}
      >
        {renderIcon()}
      </a>
    );
  }

  return (
    <button
      className={fullClassName}
      onClick={handleClick}
      onMouseDown={handleMouseDown}
      aria-label={ariaLabel}
    >
      {renderIcon()}
    </button>
  );
}

export default SidebarButton;

